import { useEffect } from "react";

export default function FloatingButton() {
  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      document.body.style.paddingBottom = "80px";
    }
    const handleResize = () => {
      if (window.innerWidth < 768) {
        document.body.style.paddingBottom = "80px";
      } else {
        document.body.style.paddingBottom = "";
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      document.body.style.paddingBottom = "";
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <a
      href="tel:0374473240"
      className="fixed bottom-4 left-4 right-4 z-50 md:hidden bg-brand-cyan text-white py-4 rounded-full font-semibold text-base flex items-center justify-center gap-2 hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap"
    >
      <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
      Appeler
    </a>
  );
}